export default function ThermalIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37">
      <defs>
        <clipPath id="clip-path">
          <rect id="Rectangle_695" data-name="Rectangle 695" width="10.497" height="14.583" fill="#fff" />
        </clipPath>
      </defs>
      <rect id="Rectangle_702" data-name="Rectangle 702" width="37" height="37" rx="18.5" opacity="0" />
      <g id="Group_1937" data-name="Group 1937" transform="translate(13.752 10.6)">
        <g id="Group_1936" data-name="Group 1936" transform="translate(0 0)" clipPath="url(#clip-path)">
          <path
            id="Path_1235"
            data-name="Path 1235"
            d="M5.9,14.583a.4.4,0,0,1-.175-.752,2.869,2.869,0,0,0,1.251-2.1,5.556,5.556,0,0,0-.915-3.847,14.013,14.013,0,0,1-1.309,2,6.956,6.956,0,0,0-1.178,1.973c-.231.813-.157,1.611.478,1.953a.4.4,0,0,1-.144.765.32.32,0,0,1-.08-.007A4.822,4.822,0,0,1,.016,9.345a6.9,6.9,0,0,1,2.026-4.01,6.708,6.708,0,0,0,2-3.977,4.345,4.345,0,0,0-.022-.91A.4.4,0,0,1,4.623.063c3.032,1.948,6.163,5.426,5.853,9.345a5.823,5.823,0,0,1-4.5,5.167.4.4,0,0,1-.077.008"
            transform="translate(0 0)"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  );
}
